import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className", "children", "type"],
  _excluded2 = ["title", "id", "children"];
import React from 'react';
import pt from 'prop-types';
import { Text } from '../';
import { appendHtmlClass, extendProps } from '../../js/util';
import getConfig from '../../js/settings';
import './_index.scss';
var LIST_TYPE = getConfig('LIST_TYPE');
var LIST_TYPE_DEFAULT = getConfig('LIST_TYPE_DEFAULT');

/** List component */

var List = function List(props) {
  var className = props.className,
    children = props.children,
    type = props.type,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  className = appendHtmlClass(className, type);
  type = LIST_TYPE[type];
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    as: type,
    className: className
  }, rest), children);
};
Object.assign(List, extendProps(Text, ['className', 'id', 'color', 'style'], {
  type: pt.oneOf(Object.keys(LIST_TYPE)),
  children: pt.arrayOf(pt.element).isRequired
}, {
  type: LIST_TYPE_DEFAULT
}));

/** ListItem component */

var ListItem = function ListItem(props) {
  var title = props.title,
    id = props.id,
    children = props.children,
    rest = _objectWithoutPropertiesLoose(props, _excluded2);
  var dt = title ? /*#__PURE__*/React.createElement(Text, Object.assign({
    as: "dt",
    id: id
  }, rest), title) : null;
  if (title) id = null;
  var el = title ? 'dd' : 'li';
  return /*#__PURE__*/React.createElement(React.Fragment, null, dt, /*#__PURE__*/React.createElement(Text, Object.assign({
    as: el,
    id: id
  }, rest), children));
};
Object.assign(ListItem, extendProps(Text, ['className', 'id', 'color', 'children', 'style'], {
  title: pt.node
}));
export { List, ListItem };